import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	strokeWidth: 1.5,
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M17.25 15.75H6.75l-1.5 7.5h13.5l-1.5-7.5Z",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.85 18.75h3.9a1.5 1.5 0 0 0 1.5-1.5v-6H.75v6a1.5 1.5 0 0 0 1.5 1.5h3.9m.6-13.5H4.677a1.5 1.5 0 0 0-1.342.829L.75 11.25h22.5l-2.585-5.171a1.5 1.5 0 0 0-1.342-.829H17.25",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.25.75H6.75v7.5h10.5V.75Z",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.625 15a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75",
			stroke: "#000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 20.25h4.5",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20stroke-width%3D%221.5%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M17.25%2015.75H6.75l-1.5%207.5h13.5l-1.5-7.5Z%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M17.85%2018.75h3.9a1.5%201.5%200%200%200%201.5-1.5v-6H.75v6a1.5%201.5%200%200%200%201.5%201.5h3.9m.6-13.5H4.677a1.5%201.5%200%200%200-1.342.829L.75%2011.25h22.5l-2.585-5.171a1.5%201.5%200%200%200-1.342-.829H17.25%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M17.25.75H6.75v7.5h10.5V.75Z%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M20.625%2015a.375.375%200%200%201%200-.75m0%20.75a.375.375%200%200%200%200-.75%22%20stroke%3D%22%23000%22%2F%3E%3Cpath%20d%3D%22M9.75%2020.25h4.5%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";
